module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pager.pages && _vm.pager.pages.length) ? _c('ul', {
    staticClass: "pagination new-pager",
    style: (_vm.ulStyles)
  }, _vm._l((_vm.pager.pages), function(page) {
    return _c('li', {
      key: page,
      staticClass: "page-item page-number",
      class: {
        'active': _vm.pager.currentPage === page
      },
      style: (_vm.liStyles)
    }, [_c('a', {
      staticClass: "page-link",
      style: (_vm.aStyles),
      on: {
        "click": function($event) {
          _vm.setPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5509db91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/JwPagination.vue
// module id = 1681
// module chunks = 1